import { ButtonSecondary } from "./newComponents/ButtonSecondary";
import {
    CalendarToday as CalendarTodayIcon,
    Save as SaveIcon,
  } from "@mui/icons-material";
import {ButtonAttention} from "./ButtonAttention";
import React from "react";
import { ButtonPrimary } from "./newComponents/ButtonPrimary";

//add icons according to buttons
const icons = { 
    save: SaveIcon,
    calendar: CalendarTodayIcon
};

export function selectButtonType(button, componentActionButtons, key, handleClick, id = null, icon) {
    const label = 'label' in button ? button.label : "";
    const className = 'className' in button ? button.className : "";
    const Icon = typeof button.icon === "string" ? icons[button.icon] : button.icon;
    const onClick = 'onClick' in button ? button.onClick : () => {
    };
    
    if (button.type === 'main') {
        componentActionButtons.push(
            <ButtonPrimary key={key} onClick={(event) => handleClick(event, onClick)} className={className} buttonIdentifier={id} startIcon={Icon ? <Icon /> : null}>
                {label}
            </ButtonPrimary>
        )
    } else if (button.type === 'secondary') {
        componentActionButtons.push(
            <ButtonSecondary key={key} onClick={(event) => handleClick(event, onClick)} className={className} buttonIdentifier={id} startIcon={Icon ? <Icon /> : null}>
                {label}
            </ButtonSecondary>
        )
    } else if (button.type === 'attention') {
        componentActionButtons.push(
            <ButtonAttention key={key} onClick={(event) => handleClick(event, onClick)} className={className} buttonIdentifier={id} startIcon={Icon ? <Icon /> : null}>
                {label}
            </ButtonAttention>
        )
    } else if (button.type === 'primary') {
        componentActionButtons.push(
            <ButtonPrimary key={key} onClick={(event) => handleClick(event, onClick)} className={className} buttonIdentifier={id} startIcon={Icon ? <Icon /> : null}>
                {label}
            </ButtonPrimary>
        )
    } else if (button.type === 'delete') {
        componentActionButtons.push(
            <ButtonPrimary key={key} onClick={(event) => handleClick(event, onClick)} className={className} buttonIdentifier={id} startIcon={Icon ? <Icon /> : null}>
                {label}
            </ButtonPrimary>
        )
    } else {
        componentActionButtons.push(
            <ButtonPrimary key={key} onClick={(event) => handleClick(event, onClick)} className={className} buttonIdentifier={id} startIcon={Icon ? <Icon /> : null}>
                {label}
            </ButtonPrimary>
        )
    }
}